import React from 'react';
import { FaChalkboardTeacher, FaBookReader, FaAward } from 'react-icons/fa';
import banner from '../../Assets/banner.jpg';
// import { TbEscalator } from 'react-icons/tb';

const AboutUs = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}

      <div className="relative h-[60vh] w-full">
        <img src={banner} alt="Kalamji Academy Banner" className="h-full w-full object-cover  " />

        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6">
          <h1 className="text-5xl font-bold animate-fadeInUp">
            Transforming Dreams into Reality
          </h1>
          <p className="mt-3 text-xl md:text-2xl animate-fadeInUp delay-200">
            Empowering students with knowledge, confidence, and excellence.
          </p>
          <a
            href="/contact"
            className="mt-6 bg-white text-[#1ba6db] font-semibold py-3 px-6 hover:bg-gray-200 transition"
          >
            Get Started Today
          </a>
        </div>
      </div>

      {/* About Section */}

      <div className="max-w-screen-lg mx-auto px-6 py-12">
        <h2 className="text-4xl font-bold text-gray-800 text-center mb-8">
          Welcome to <span className="text-[#1ba6db]">Kalamji Academy</span>
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed text-center">
          At <strong>Kalamji Academy</strong>, we believe in nurturing young minds and shaping future leaders. 
          Our institution is dedicated to providing high-quality education with expert guidance, 
          cutting-edge teaching methods, and a supportive learning environment.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          <div className="bg-white p-6 border text-center">
            <FaBookReader className="text-[#1ba6db] text-5xl mx-auto mb-4" />
            <h3 className="text-2xl font-semibold text-[#1ba6db]">Personalized Coaching</h3>
            <p className="text-gray-600 mt-3">
              Tailored learning paths for CBSE, ICSE, State Board, NEET, JEE, and competitive exams.
            </p>
          </div>

          <div className="bg-white p-6 border text-center">
            <FaChalkboardTeacher className="text-[#1ba6db] text-5xl mx-auto mb-4" />
            <h3 className="text-2xl font-semibold text-[#1ba6db]">Expert Faculty</h3>
            <p className="text-gray-600 mt-3">
              Our educators bring years of experience and innovative teaching methods.
            </p>
          </div>

          <div className="bg-white p-6 border text-center">
            <FaAward className="text-[#1ba6db] text-5xl mx-auto mb-4" />
            <h3 className="text-2xl font-semibold text-[#1ba6db]">Success-Oriented</h3>
            <p className="text-gray-600 mt-3">
              We focus on excellence, career success, and holistic development.
            </p>
          </div>
        </div>
      </div>
      {/* Call to Action Section */}      
      <section className="bg-[#1ba6db] text-white py-14 text-center">

        <div className="max-w-screen-lg mx-auto px-6">
          <h2 className="text-3xl font-bold mb-4">Your   to Success Starts Here</h2>
          <p className="text-lg mb-6">
            Enroll today and take the first step toward a brighter future.
          </p>
          <a
            href="/contact"
            className="inline-block bg-white text-[#1ba6db] font-bold py-3 px-6 hover:bg-gray-100 transition"
          >
            Join Us Now
          </a>
        </div>
        
      </section>
      {/* <TbEscalator/> */}
    </div>  
  );
};

export default AboutUs;